import React, { useState } from 'react';
import {
  TextField,
  Button,
  Grid,
  Box,
  FormHelperText,
  CircularProgress,
  Alert
} from '@mui/material';
import { staffCreate } from '../../../Services/Services'; // Make sure to use named export or default correctly

const AddNewUser = ({ setUsers, setOpenAddModal }) => {
  const [formData, setFormData] = useState({
    name: '',
    mo_no: '',
    email: '',
    password: '',
    confirmPassword: '',
    address: '',
  });

  const [contactNoError, setContactNoError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [responseMessage, setResponseMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMobileChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/\D/g, '');
    setFormData((prev) => ({ ...prev, [name]: numericValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setResponseMessage({ type: '', text: '' });

    // Validation
    if (formData.mo_no.length !== 10) {
      setContactNoError('Mobile Number must be exactly 10 digits');
      return;
    } else {
      setContactNoError('');
    }

    if (formData.password !== formData.confirmPassword) {
      setPasswordError('Passwords do not match');
      return;
    } else {
      setPasswordError('');
    }

    setLoading(true);

    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        mo_no: formData.mo_no,
        password: formData.password,
        address: formData.address,
      };

      const res = await staffCreate(payload);
      setUsers(res)
      setOpenAddModal(false)
      setResponseMessage({
        type: 'success',
        text: res?.message || 'User created successfully!',
      });

      setFormData({
        name: '',
        mo_no: '',
        email: '',
        password: '',
        confirmPassword: '',
        address: '',
      });
    } catch (error) {
      setResponseMessage({
        type: 'error',
        text:
          error.response?.data?.message ||
          'Something went wrong while creating the user.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="form-container-user" sx={{ mt: 2 }}>
      {responseMessage.text && (
        <Alert severity={responseMessage.type} sx={{ mb: 2 }}>
          {responseMessage.text}
        </Alert>
      )}

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              variant="outlined"
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Mobile No."
              name="mo_no"
              value={formData.mo_no}
              onChange={handleMobileChange}
              variant="outlined"
              required
              inputProps={{ maxLength: 10 }}
              error={!!contactNoError}
            />
            {contactNoError && (
              <FormHelperText error>{contactNoError}</FormHelperText>
            )}
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              variant="outlined"
              type="email"
              required
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              variant="outlined"
              type="password"
              required
              error={!!passwordError}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Confirm Password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              variant="outlined"
              type="password"
              required
              error={!!passwordError}
            />
            {passwordError && (
              <FormHelperText error>{passwordError}</FormHelperText>
            )}
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              variant="outlined"
              multiline
              rows={2}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
              sx={{ py: 1 }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default AddNewUser;
